module.exports = __webpack_public_path__ + "img/рз_16.0ef9e7fe.png";